
import { createAction } from 'typesafe-actions';
import { IDam } from '../../@types/model/dam/dam';
import { IDamWeeklyReading } from '../../@types/model/dam/weeklyReading';

export const damSetList = createAction('DAM_SET_LIST', resolve => (dams : Array<IDam>) => resolve(dams));
export const damSetSelected = createAction('DAM_SET_SELECTED', resolve => (selectedDam ?: IDam) => resolve(selectedDam));
export const damSetLoading = createAction('DAM_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
export const damSetReadings = createAction('DAM_SET_READINGS', resolve => (readings : Array<IDamWeeklyReading>) => resolve(readings));
export const damSetReadingLoading = createAction('DAM_SET_LOADING_READINGS', resolve => (loading : boolean) => resolve(loading));